/* eslint-disable */
//@ts-nocheck
import React, { useEffect, useLayoutEffect, useState, useReducer } from 'react'
import { ConfigProvider, App as AntdApp } from 'antd';
import lightToken from 'themes/light.json';
import { I18nextProvider, initReactI18next } from "react-i18next";
import { QueryClient, QueryClientProvider, useQuery } from 'react-query'
import i18next from "i18next";
import enUS from 'antd/locale/en_US';
import arEG from 'antd/locale/ar_EG';

import { localeMapValue } from 'types/layout';
import { Organization } from 'types/app';
import axios from 'axios';
import { Locale } from 'antd/lib/locale';
import dayjs from 'dayjs';
import 'dayjs/locale/ar-sa';
import { mixPanelConfig } from '../../utils/MispanelConfig';
import { PlansContext } from 'contexts/plans';
import { QueryProvider } from 'contexts/QueryProvider';

const { components, ...globalTokens } = lightToken;

const arLocaleWithShortDays: Locale = {
  ...arEG,
  DatePicker: arEG.DatePicker ? {
    ...arEG.DatePicker,
    lang: {
      ...arEG.DatePicker.lang,
      shortWeekDays: ["ح", "ن", "ث", "ر", "خ", "ج", "س"],
    },
  } : undefined,
};

i18next
  .use(initReactI18next)
  .init({
    resources: {
      [window.I18n.locale]: {
        translation: window.I18n
      }
    },
    lng: window.I18n.locale
  })
  .catch((err) => console.error('i18n initialization failed', err));
  

const localeMap = new Map<string, localeMapValue>([
  ['en', {locale: enUS, dir: 'ltr', fontFamily: globalTokens.fontFamily}],
  ['ar', {locale: arLocaleWithShortDays, dir: 'rtl', fontFamily: 'Cairo'}]
])

globalTokens.fontFamily = localeMap.get(i18next.language)?.fontFamily ?? globalTokens.fontFamily;

export const antdConfigProps = {
  theme: { components, token: globalTokens },
  locale: localeMap.get(i18next.language)?.locale,
  direction: localeMap.get(i18next.language)?.dir
}

interface AppProps {
  modulePath: string;
  pagePath: string;
  isPos: boolean
}

const App: React.FC<AppProps> = ({modulePath, pagePath, ...props}) => {
  const [Page, setPage] = useState<React.ReactElement | null>(null);
  
  useQuery<Organization>({
    queryKey: ['OrgDetails'],
    queryFn: async () => {
      const response = await axios.get<Organization>('/tenant/dashboards/current_organization.json');
      return response.data;
    },
    enabled: Boolean(Page)
  })

  useLayoutEffect(() => {
    import(`pages/${modulePath}/${pagePath}`)
      .then((Module) => {
        setPage(<Module.default {...props} />)
      })
      .catch(() => {
        throw new Error(`Couldn't find the page`)
      })
  }, [])

  useEffect(() => {
    dayjs.locale(i18next.language === "ar" ? "ar-sa" : i18next.language);
  }, [i18next.language]);

  useEffect(() => {
    mixPanelConfig();
  }, []);

  return (
    Page
  )
}

const AppWrapper: React.FC<AppProps> = ({isPos, ...props}) => (
  <PlansContext.Provider value={{ isPos }}>
    <I18nextProvider i18n={i18next}>
      <ConfigProvider {...antdConfigProps} >
        <QueryProvider>
          <AntdApp>
            <App {...props} />
          </AntdApp>
        </QueryProvider>
      </ConfigProvider>
    </I18nextProvider>
  </PlansContext.Provider>
);

AppWrapper.displayName = "AppWrapper";
export default AppWrapper;